import Vue from 'vue';
import ViewUI from 'view-design';
import Util from '../libs/util';
import VueRouter from 'vue-router';
import Cookies from 'js-cookie';
import {routers, otherRouter} from './router';

Vue.use(VueRouter);

// 路由配置
const RouterConfig = {
    mode: 'history',
    routes: routers
};

export const router = new VueRouter(RouterConfig);
router.beforeEach((to, from, next) => {
    //如果 是 index.html，那就重定向到首页
    if(to.path == '/index.html'){
        next('/');
    }

    else if (to.matched.length === 0) { //匹配前往的路由不存在
        if(from.name){
            next({
                name: from.name
            })
        }
        else{
            next('/404')
        }
        // from.name ? next({
        //     name: from.name
        // }) : next('/404'); //判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
    } else {
        next(); //如果匹配到正确跳转
    }
    ViewUI.LoadingBar.start();
    Util.title(to.meta.title);
    if (Cookies.get('locking') == '1' && to.name !== 'locking') {
        // 判断当前是否是锁定状态
        next({
            replace: true,
            name: 'locking'
        });
    } else if (Cookies.get('locking') == '0' && to.name == 'locking') {
        next(false);
    } else {
        Util.toDefaultPage([...routers], to.name, router, next);
        // if (!Cookies.get('userInfo') && to.name !== 'login' && to.name !== 'regist' && to.name !== 'regist-result' && to.name !== 'relate') { // 判断是否已经登录且前往的页面不是登录页
        //     next({
        //         name: 'login'
        //     });
        // } else if (Cookies.get('userInfo') && to.name == 'login') {
        //     // 判断是否已经登录且前往的是登录页
        //     Util.title();
        //     next({
        //         name: 'home_index'
        //     });
        // } else {
        //     Util.toDefaultPage([...routers], to.name, router, next);
        // }
    }
});
router.afterEach((to) => {
    Util.openNewPage(router.app, to.name, to.params, to.query);
    ViewUI.LoadingBar.finish();
    window.scrollTo(0, 0);
});

const originalPush = VueRouter.prototype.replace
VueRouter.prototype.push = function push(location) {
    try {
        return originalPush.call(this, location)
    } catch (error) {
        console.error(error)
    }
}